var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col items-left mr-4 mb-4 rounded border p-2",class:{
    'border-pink': this.activeOption === _vm.option.id,
    'border-grey-200': this.activeOption !== _vm.option.id,
  },on:{"click":_vm.updateActiveOption,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.updateActiveOption.apply(null, arguments)}}},[_c('label',{staticClass:"flex cursor-pointer",class:{
      'cursor-not-allowed': _vm.option.coming_soon,
      'cursor-pointer': !_vm.option.coming_soon,
    }},[_c('span',{staticClass:"w-6 h-5 inline-block mr-1 mt-1 rounded-full border",class:{
        'border-grey bg-pink text-pink activeOptionRadio':
          this.activeOption === _vm.option.id,
        'border-grey': this.activeOption !== _vm.option.id && !_vm.option.coming_soon,
        'border-grey-200': _vm.option.coming_soon,
      }}),_c('div',{staticClass:"ml-2 flex flex-col w-full"},[_c('label',{staticClass:"font-semibold",class:{
          'text-pink': this.activeOption === _vm.option.id,
          'text-grey-700':
            this.activeOption !== _vm.option.id && !_vm.option.coming_soon,
          'text-grey-300': _vm.option.coming_soon,
        }},[_vm._v(" "+_vm._s(_vm.option.title)+" "),(_vm.option.coming_soon)?_c('div',{staticClass:"text-xs"},[_vm._v("("+_vm._s(_vm.$t('frontend_coming_soon'))+")")]):_vm._e()]),_c('div',{staticClass:"text-grey-500"},[_vm._v(" "+_vm._s(_vm.option.description)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }